export default __webpack_public_path__ + "social-development@2x.c52f2b96.png";